document.addEventListener('DOMContentLoaded', function () {
  const pills = document.querySelectorAll('.variant-pill');
  const variantImage = document.getElementById('variant-image');
  const extraImageContainer = document.getElementById('extra-image-container');
  const extraImage = document.getElementById('extra-image');
  const wrapper = document.getElementById('wrapper');
  const container = document.querySelector('.expanding-cards-container');
  const description = document.getElementById('variant-description');
  
  function changeVariant(pill) {
    const imageUrl = pill.getAttribute('data-image');
    const extraImageUrl = pill.getAttribute('data-extra-image');
    const bgColor = pill.getAttribute('data-bg');
    const bgImage = pill.getAttribute('data-bg-image');
    const descriptionText = pill.getAttribute('data-description');
    
    // Fade out the content before changing the variant
    container.style.opacity = 0;
    
    // Wait for the fade-out to complete, then update everything
    setTimeout(() => {
      // Update main variant image
      variantImage.src = imageUrl;

      // Update extra image and ensure it's inside the correct section
      if (extraImageUrl) {
        extraImage.src = extraImageUrl;
        extraImage.style.display = "block";

        // Append extra image to the correct section
        container.appendChild(extraImageContainer);
      } else {
        extraImage.style.display = "none";
      }

      // Update background color of the wrapper if defined
      if (bgColor) {
        wrapper.style.backgroundColor = bgColor; // Apply background color
        wrapper.style.backgroundImage = 'none'; // Remove background image if color is applied
      } else {
        wrapper.style.backgroundColor = ''; // Reset color if no color is set
      }

      // Update background image of the container if defined
      if (bgImage) {
        container.style.backgroundImage = `url(${bgImage})`;
        container.style.backgroundSize = 'cover';
        container.style.backgroundPosition = 'center';
      } else {
        container.style.backgroundImage = 'none'; // Remove background image if not set
      }

      description.innerHTML = ''; // Clear it first
      void description.offsetWidth; // Force reflow to trigger update
      description.innerHTML = descriptionText; // Set new description with HTML rendering

      // Show the variant image and description with fade-in effect
      document.getElementById('variant-image-container').classList.add('display');
      document.getElementById('variant-description-container').classList.add('display');
      
      // Fade the content back in
      setTimeout(() => {
        container.style.opacity = 1; // Fade in the container
      }, 100); // Slight delay before fading in

      // Reduce the wrapper height after clicking the pill with a smooth transition
      wrapper.style.minHeight = '400px';
    }, 300); // Fade-out duration should match the CSS transition time
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      changeVariant(pill);
    });
  });

  // Function to darken color (if needed)
  function darkenColor(hex, percent) {
    let num = parseInt(hex.slice(1), 16),
      amt = Math.round(2.55 * percent),
      r = (num >> 16) - amt,
      g = ((num >> 8) & 0x00FF) - amt,
      b = (num & 0x0000FF) - amt;

    return `rgb(${r < 0 ? 0 : r}, ${g < 0 ? 0 : g}, ${b < 0 ? 0 : b})`;
  }
});
